// The one place the web renders times. Everything goes through an explicit IANA
// zone, never the implicit locale of the browser's `toLocale*String`, and carries
// its zone label ("Sep 28, 10:11 AM MDT"). Ported from qa-mission-control
// web/src/lib/time.ts, so the mesh's UIs render alike (mesh time contract: MC
// docs/time-and-timezones.md §4.1). ESLint bans toLocale*String everywhere else.

/** The zone times are shown in: the browser's own, until this app reads the
 *  viewer's pinned zone from Mission Control's /auth/me. */
export function viewerTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

const OPTIONS = {
  /** "Sep 28, 10:11 AM MDT" — table cells. */
  compact: { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' },
  /** "Sep 28, 2026, 10:11:07 AM MDT" — detail views. */
  full: { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit', timeZoneName: 'short' },
  /** "Sep 28, 2026" — the calendar day the instant falls on in `tz`. */
  date: { year: 'numeric', month: 'short', day: 'numeric' },
}

const formatters = new Map()

function formatter(tz, style) {
  const key = `${style}|${tz}`
  let f = formatters.get(key)
  if (!f) {
    try {
      f = new Intl.DateTimeFormat('en-US', { ...OPTIONS[style], timeZone: tz })
    } catch {
      // An unknown zone name must not take the page down.
      f = new Intl.DateTimeFormat('en-US', { ...OPTIONS[style], timeZone: viewerTimeZone() })
    }
    formatters.set(key, f)
  }
  return f
}

/** Render an instant (ISO 8601 with an offset or `Z`) in `tz`, labelled with the
 *  zone abbreviation. An unparseable value comes back as-is. */
export function formatInstant(iso, { tz = viewerTimeZone(), style = 'compact' } = {}) {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return formatter(tz, style).format(d)
}

/** The exact instant in UTC ("2026-09-28T16:11:07Z"), for `title` tooltips. */
export function formatUtcInstant(iso) {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return `${d.toISOString().slice(0, 19)}Z`
}
